import React, { useEffect, useState, } from 'react'
import { useParams } from 'react-router';
import { Layout, Table, Button, Space, PageHeader, Radio, Descriptions, Row, Col, Statistic, Checkbox } from 'antd';
import { LoadingOutlined, TableOutlined, AppstoreOutlined } from "@ant-design/icons";
import MenuService from '../../services/MenuService';
import R2Footer from "../../components/Footer";
import { useHistory } from "react-router";
import modes from '../../components/view-modes';

const { Content } = Layout;

export default function MenuItemDetails() {
    const [loading, setLoading] = useState(false);
    const [menuItem, setMenuItem] = useState({});
    const [mode, setMode] = useState(modes.table);
    const history = useHistory();
    const params = useParams();

    useEffect(() => {
        getMenuItem();
    }, []);

    const getMenuItem = async () => {
        if (params.menuItemId) {
            const menuItem = await MenuService.getMenuItem(parseInt(params.menuItemId));
            setMenuItem(menuItem);
        }
    }

    return (
        <Layout style={{ padding: '0 24px 24px' }}>
            <Content
                className="site-layout-background"
                style={{
                    padding: 24,
                    margin: '16px 0px',
                    minHeight: 280,
                }}
            >
                {
                    loading ?
                        <LoadingOutlined style={{ fontSize: '30px' }} />
                        :
                        <Space direction="vertical" style={{ width: '100%' }}>
                            <PageHeader
                                title={menuItem.name}
                                onBack={() => history.goBack()}
                                extra={[
                                    <Button className="success" onClick={() => history.push(`/menus/${params.menuId}/edit-menu-item/${params.menuItemId}`)}>Edit Menu Item</Button>
                                ]}>
                                <Space direction="vertical">
                                    <Descriptions>
                                        <Descriptions.Item label="Description">
                                            {menuItem.description}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Row>
                                        <Col span={6}>
                                            <img src={menuItem.photo_url} />
                                        </Col>
                                        <Col span={18}>
                                            <Row>
                                                <Col span={8}>
                                                    <Statistic title="Price" prefix="$" value={menuItem.price} />
                                                </Col>
                                                <Col span={8}>
                                                    <Statistic title="Prep Time" suffix="(in mins)" value={menuItem.prep_time_minutes} />
                                                </Col>
                                                <Col span={8}>
                                                    <Statistic title="Regular Max Quantity" value={menuItem.regular_max_quantity} />
                                                </Col>

                                                <Col span={6}>
                                                    <Checkbox checked={menuItem.is_active}>
                                                        Active Item?
                                                    </Checkbox>
                                                </Col>
                                                <Col span={6}>
                                                    <Checkbox checked={menuItem.is_vegetarian}>
                                                        Vegetarian Item?
                                                    </Checkbox>
                                                </Col>
                                                <Col span={6}>
                                                    <Checkbox checked={menuItem.is_vegan}>
                                                        Vegan Item?
                                                    </Checkbox>
                                                </Col>
                                                <Col span={6}>
                                                    <Checkbox checked={menuItem.is_gluten_free}>
                                                        Gluten-free Item?
                                                    </Checkbox>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Space>
                            </PageHeader>
                        </Space>
                }
            </Content>
            <R2Footer />
        </Layout>
    )
}
